<div class="stock-options">
  <ul class="stock-options__items">
    <li class="stock-options__item">
      <div class="stock-options__bullet" [class.out-of-stock]="!isInStock"></div>
      <span class="stock-options__item-status">{{ stockText | translate | async }}</span>
      @if (isShowItemsLeft) {
        <span class="stock-options__item-availability">
          {{ salableQty }}
          <ng-container *ngTemplateOutlet="qtyTmpl; context: { $implicit: salableQty }">
          </ng-container>
        </span>
      }
    </li>
  </ul>
</div>

<ng-template #qtyTmpl let-qty>
  <ng-container [ngPlural]="qty">
    <ng-template ngPluralCase="1">{{ 'item left' | translate | async }}</ng-template>
    <ng-template ngPluralCase="other">{{ 'items left' | translate | async }}</ng-template>
  </ng-container>
</ng-template>
